// src/components/Plans.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";

// Import your fonts and CSS
import "../fonts/bootstrap-icons.woff";
import "../fonts/bootstrap-icons.woff2";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/main.css";
import "../css/bootstrap-icons.css";

function Header() {
  return (
    <header className="site-header d-flex flex-column justify-content-center align-items-center">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-5 col-12">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/">Homepage</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Plans and Pricing
                </li>
              </ol>
            </nav>
            <h2 className="text-white">Plans And Pricing</h2>
          </div>
        </div>
      </div>
    </header>
  );
}

function Section1({ user }) {
  // Determine the link for the "Buy Now!" buttons.
  // If user is logged in, link to "/purchase"; otherwise, link to "/login"
  const buyLink = user ? "/purchase" : "/login";

  return (
    <section className="section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-12 text-center">
            <h3 className="mb-4">Plans and Pricing</h3>
          </div>

          <div className="col-lg-8 col-12 mt-3 mx-auto">
            <div className="custom-block custom-block-topics-listing bg-white shadow-lg mb-5">
              <div className="d-flex">
                <img
                  src="basic.png"
                  className="custom-block-image img-fluid"
                  alt="Basic Plan"
                />
                <div className="custom-block-topics-listing-info d-flex">
                  <div>
                    <h5 className="mb-2">Basic</h5>
                    <p className="mb-0">
                      The most basic plan, you will get 30 hours of AI, and exclusive waitlist bypass.
                    </p>
                    <a href={buyLink} className="btn custom-btn mt-3 mt-lg-4">
                      Buy Now!
                    </a>
                  </div>
                  <span className="badge bg-design rounded-pill ms-auto">15$</span>
                </div>
              </div>
            </div>

            <div className="custom-block custom-block-topics-listing bg-white shadow-lg mb-5">
              <div className="d-flex">
                <img
                  src="plus.png"
                  className="custom-block-image img-fluid"
                  alt="Plus Plan"
                />
                <div className="custom-block-topics-listing-info d-flex">
                  <div>
                    <h5 className="mb-2">Plus</h5>
                    <p className="mb-0">
                      With the PLUS plan you'll get 50 hours of AI usage, instant delivery, and exclusive access to our own custom trained AI.
                    </p>
                    <a href={buyLink} className="btn custom-btn mt-3 mt-lg-4">
                      Buy Now!
                    </a>
                  </div>
                  <span className="badge bg-advertising rounded-pill ms-auto">30$</span>
                </div>
              </div>
            </div>

            <div className="custom-block custom-block-topics-listing bg-white shadow-lg mb-5">
              <div className="d-flex">
                <img
                  src="premium.png"
                  className="custom-block-image img-fluid"
                  alt="Premium Plan"
                />
                <div className="custom-block-topics-listing-info d-flex">
                  <div>
                    <h5 className="mb-2">Premium</h5>
                    <p className="mb-0">
                      With our premium plan, you get all the previous benefits in addition to unlimited AI hours, update priority, and access to our exclusive support to help you on your mission with <strong>Nutriplan!</strong>
                    </p>
                    <a href={buyLink} className="btn custom-btn mt-3 mt-lg-4">
                      Buy Now!
                    </a>
                  </div>
                  <span className="badge bg-music rounded-pill ms-auto">50$</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function Plans() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null); // local state for the authenticated user
  const [loading, setLoading] = useState(true);

  // Listen to authentication changes
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      if (currentUser) {
        // User is logged in; set the user in state and stay on /plans
        setUser(currentUser);
      } else {
        // If no user, redirect to /login
        navigate("/login");
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, [navigate]);

  // Optionally, you can display a loader while checking the auth state.
  if (loading) {
    return;
  }

  function Divider() {
    return (
      <div className="container">
        <hr className="my-5" />
      </div>
    );
  }

  return (
    <>
      <Header />
      <Section1 user={user} />
      <Divider />
    </>
  );
}
